import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6bb47f92&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb47f92')) {
      api.createRecord('6bb47f92', component.options)
    } else {
      api.reload('6bb47f92', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=6bb47f92&lang=pug&", function () {
      api.rerender('6bb47f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/Header.vue"
export default component.exports